(function () {
	const testimonials = (isUpdate) => {
		const testimonialsSections = document.querySelectorAll('.testimonials-section');
		const cardsSliders = document.querySelectorAll('.testimonials__cards');
		const textSliders = document.querySelectorAll('.testimonials__slider');
		const prevArrows = document.querySelectorAll('.testimonials__button--prev');
		const nextArrows = document.querySelectorAll('.testimonials__button--next');
		const navigation = document.querySelectorAll('.testimonials__navigation');

		const removeNavTabindex = (index) => {
			if (nextArrows[index]) nextArrows[index].removeAttribute('tabindex');
			if (prevArrows[index]) prevArrows[index].removeAttribute('tabindex');
		};

		const initSliders = margin => {
			textSliders.forEach((slider, index) => {
				const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
				const sourceSlidesCount = slider.querySelectorAll('.testimonials__slide').length;
				const loopedSlides = sourceSlidesCount === 2 ? 2 : Math.min(3, sourceSlidesCount);
				const liveRegion = slider.querySelector('.testimonials__live-region');

				const textSlider = new Swiper(slider, {
					slidesPerView: 1,
					loop: true,
					loopedSlides: loopedSlides,
					keyboard: {
						enabled: true,
					},
					a11y: {
						enabled: true,
						prevSlideMessage: 'Previous testimonial',
						nextSlideMessage: 'Next testimonial',
						firstSlideMessage: 'This is the first testimonial',
						lastSlideMessage: 'This is the last testimonial',
					},
					navigation: {
						nextEl: nextArrows[index],
						prevEl: prevArrows[index],
					},
					pagination: {
						el: navigation[index],
						type: "fraction",
					},
					createElements: true,
					effect: prefersReducedMotion ? "slide" : "fade",
					fadeEffect: {
						crossFade: true,
					},
				});

				const cardSlider = new Swiper(cardsSliders[index], {
					slidesPerView: 1,
					loopedSlides: loopedSlides,
					loopedSlidesLimit: loopedSlides,
					loop: true,
					variableWidth: true,
					effect: prefersReducedMotion ? "slide" : "creative",
					creativeEffect: {
						limitProgress: loopedSlides - 1,
						prev: {
							opacity: 0,
							translate: [-margin, 0, 0],
						},
						next: {
							translate: [margin, 0, 0],
							scale: 0.94,
						},
					},
				});

				cardSlider.controller.control = textSlider;
				textSlider.controller.control = cardSlider;
				removeNavTabindex(index);

				const getFocusableElements = (container) => {
					if (!container) return [];
					return Array.from(
						container.querySelectorAll(
							"a[href], button:not([disabled]), textarea:not([disabled]), input:not([type='hidden']):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])",
						),
					).filter((element) => element.getAttribute('aria-hidden') !== 'true');
				};

				const updateSlideFocusability = () => {
					textSlider.slides.forEach((slide) => {
						const isActive = slide.classList.contains('swiper-slide-active');
						slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

						slide
							.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')
							.forEach((element) => {
								if (isActive) {
									if (!element.hasAttribute('data-swiper-prev-tabindex')) return;

									const previousTabindex = element.getAttribute('data-swiper-prev-tabindex');
									if (previousTabindex === '') {
										element.removeAttribute('tabindex');
									} else {
										element.setAttribute('tabindex', previousTabindex);
									}
									element.removeAttribute('data-swiper-prev-tabindex');
									return;
								}

								if (!element.hasAttribute('data-swiper-prev-tabindex')) {
									element.setAttribute(
										'data-swiper-prev-tabindex',
										element.getAttribute('tabindex') || '',
									);
								}
								element.setAttribute('tabindex', '-1');
							});
					});
				};

				updateSlideFocusability();
				textSlider.on('slideChangeTransitionEnd', updateSlideFocusability);

				const handleTabSlideNavigation = (event) => {
					if (event.key !== 'Tab') return;

					const activeSlide = textSlider.slides[textSlider.activeIndex];
					if (!activeSlide || !activeSlide.contains(event.target)) return;

					const focusableElements = getFocusableElements(activeSlide);
					if (!focusableElements.length) return;

					const firstFocusable = focusableElements[0];
					const lastFocusable = focusableElements[focusableElements.length - 1];
					const shouldMovePrev = event.shiftKey && event.target === firstFocusable;
					const shouldMoveNext = !event.shiftKey && event.target === lastFocusable;

					if (!shouldMovePrev && !shouldMoveNext) return;

					event.preventDefault();

					textSlider.once('slideChangeTransitionEnd', () => {
						const nextActiveSlide = textSlider.slides[textSlider.activeIndex];
						const nextFocusableElements = getFocusableElements(nextActiveSlide);
						if (!nextFocusableElements.length) return;

						const targetElement = shouldMovePrev
							? nextFocusableElements[nextFocusableElements.length - 1]
							: nextFocusableElements[0];

						if (targetElement) {
							targetElement.focus();
						}
					});

					if (shouldMovePrev) {
						textSlider.slidePrev();
					} else {
						textSlider.slideNext();
					}
				};

				if (slider.tabSlideNavigationHandler) {
					slider.removeEventListener('keydown', slider.tabSlideNavigationHandler);
				}

				slider.tabSlideNavigationHandler = handleTabSlideNavigation;
				slider.addEventListener('keydown', handleTabSlideNavigation);

				if (liveRegion) {
					const announceSlide = () => {
						liveRegion.textContent = `Testimonial ${textSlider.realIndex + 1} of ${sourceSlidesCount}`;
					};
					announceSlide();
					textSlider.on('slideChange', announceSlide);
				}

				if (isUpdate) {
					setTimeout(function () {
						cardSlider.update();
						textSlider.update();
						removeNavTabindex(index);
					}, 800);
				}
			});
		}


		const testimonialsResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				initSliders(40);
			} else if (entry.contentRect.width > 991) {
				initSliders(110);
			}
		});

		testimonialsSections.forEach(section => {
			testimonialsResizeObserver.observe(section);
		})

	};

	testimonials();

	document.addEventListener('shopify:section:load', function () {
		testimonials(true);
	});

})();
